// libs
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Component
import CustomLink from '../../tools/customLink/CustomLink';

// Props and Context
const propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};

const defaultProps = {
  links: [],
  className: null,
};

// LinkList Component
function Linklist(props) {
  const { links, className: classes } = props;
  return (
    <ul className={`links ${classes}__links`}>
      {links.length > 0 &&
      links.filter(({ hidden }) => !hidden).map(({ title, lang, path, subNav, icon = null }) =>
        <li
          className={classNames(
            'link',
            `link__${title}`,
            `${classes}__link`,
            { [`link__${icon}`]: icon },
          )}
          key={title}
        >
          <CustomLink path={path} lang={lang}>
            {title}
          </CustomLink>
          {!!subNav && <Linklist links={subNav} className={classes} />}
        </li>,
      )}
    </ul>
  );
}

Linklist.propTypes = propTypes;
Linklist.defaultProps = defaultProps;

export default Linklist;



// WEBPACK FOOTER //
// ./src/app/components/layouts/nav/Linklist.js